import axiosInstance from '@/services/api/axiosInstance';

/**
 * The Candle Card section's data.
 *
 * One call rather than four: the section is a landing place people open
 * directly, and a card that assembles itself from several round trips shows
 * its seams on a slow connection.
 */

/**
 * GET /user/candle-card
 *
 * -> { tier, photosKeptUntil, cards[], plans[],
 *      reports: [{ consultationId, analysisId, agentKey, serviceName,
 *                  state: 'reviewed'|'preliminary', at, reviewedAt,
 *                  physicianName, metrics }] }
 *
 * `metrics` is the analysis bot's own summary JSON, passed through untouched.
 * Nothing here interprets it — `features/candleCard/reportAdapters.js` is the
 * single place that knows what a given bot puts in there.
 */
export async function getCandleCard() {
  const res = await axiosInstance.get('/user/candle-card');
  return res.data.data ?? res.data;
}

export const candleCardApi = { getCandleCard };
export default candleCardApi;
